import { createPath } from "@odata/BindingContext";
import {
    BusinessPartnerBankAccountEntity,
    BusinessPartnerContactEntity,
    BusinessPartnerEntity,
    BusinessPartnerIssuedDocumentDefaultEntity,
    BusinessPartnerReceivedDocumentDefaultEntity,
    DocumentBusinessPartnerEntity,
    DocumentEntity
} from "@odata/GeneratedEntityTypes";
import { PayerReliabilityStatusCode } from "@odata/GeneratedEnums";
import { TFieldDefinition } from "@pages/PageUtils";
import { isDefined } from "@utils/general";
import i18next from "i18next";
import React from 'react';

import { ColoredText } from "../../global.style";
import { TValue } from "../../global.types";

export const BusinessPartnerSaveErrors = [
    "BusinessPartnerCombinationOfNameAndLegalNumberAlreadyExists",
    "BusinessPartnerCombinationOfNameAndAddressAlreadyExists"
];

export const DocumentBusinessPartnerAdditionalProperties = {
    id: createPath(DocumentEntity.BusinessPartner, DocumentBusinessPartnerEntity.BusinessPartner),
    additionalProperties: [
        {
            id: BusinessPartnerEntity.PayerReliabilityStatusCode,
        },
        {
            id: BusinessPartnerEntity.BankAccounts,
            additionalProperties: [{
                id: BusinessPartnerBankAccountEntity.CountryCode
            }, {
                id: BusinessPartnerBankAccountEntity.AccountNumber
            }, {
                id: BusinessPartnerBankAccountEntity.BankCode
            }, {
                id: BusinessPartnerBankAccountEntity.IBAN
            }, {
                id: BusinessPartnerBankAccountEntity.SWIFT
            }, {
                id: BusinessPartnerBankAccountEntity.AbaNumber
            }, {
                id: BusinessPartnerBankAccountEntity.BankAccountRegistrationStatusCode
            }]
        },
        {
            id: BusinessPartnerEntity.Contacts,
            additionalProperties: [{
                id: BusinessPartnerContactEntity.FirstName
            }, {
                id: BusinessPartnerContactEntity.LastName
            }, {
                id: BusinessPartnerContactEntity.Email
            }, {
                id: BusinessPartnerContactEntity.PhoneNumber
            }]
        },
        {
            id: BusinessPartnerEntity.IssuedDocumentDefault,
            additionalProperties: [{
                id: BusinessPartnerIssuedDocumentDefaultEntity.DaysDue
            }, {
                id: BusinessPartnerIssuedDocumentDefaultEntity.VatClassification
            }]
        },
        {
            id: BusinessPartnerEntity.ReceivedDocumentDefault,
            additionalProperties: [{
                id: BusinessPartnerReceivedDocumentDefaultEntity.DaysDue
            }, {
                id: BusinessPartnerReceivedDocumentDefaultEntity.VatClassification
            }]
        }
    ]
};

export const getPayerReliabilityStatusCodeDef = (): TFieldDefinition => {
    return {
        label: i18next.t("BusinessPartner:ReliabilityCheck"),
        formatter: (val: TValue) => {
            if (isDefined(val)) {
                const title = i18next.t(`BusinessPartner:${val === PayerReliabilityStatusCode.Unreliable ? "NotReliable" : "Reliable"}`).toString();
                const color = val === PayerReliabilityStatusCode.Unreliable ? "C_SEM_text_bad" : "C_SEM_el_good";

                const colorWrapper = <ColoredText color={color}>{title}</ColoredText>;

                return { tooltip: title, value: colorWrapper };
            }

            return null;
        }
    };
};